<template>
  <v-card :width="cardSize" :class="cardClass" :height="cardSize"
    @dragover.prevent="dragOver" @dragleave.prevent="dragLeave" @drop.prevent="dndDrop"
    justify="center" align="center" :style="`margin: ${marginSize}px`"
    elevation="0" :color="dndCallOver ? 'light-blue' : 'transparent'" @click="onBuddyClick()">
      <CallTime :calls="calls" :lightMode="true" :cardSize="cardSize" :nameFontSize="nameFontSize" :marginSize="marginSize"
        v-if="displayCallers" style="z-index: 998;position: absolute;width: 100%"/>
      <div class="buddy-info">
        <StatusAvatar class="mb-2" :user="buddy" :avatar-size="`${superLightItemSize}px`" :badge-size="`${badgeSize}px`"/>
        <span :style="`font-size: ${nameFontSize}px;line-height: 1.5em;margin-top: ${marginSize}px`">{{ buddy.name }}</span>
      </div>
    <TransferCallDialog :buddy="buddy" :confirmXferDlg="confirmXferDlg" :xferCallId="xferCallId"
    :xferNumber="xferNumber" @close-xfer-dialog="closeXferDialog"/>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import StatusAvatar from './status_avatar'
import CallTime from './calltime.vue'
import TransferCallDialog from './transfer_call_dialog.vue'
import EmbeddedLocalStorage from '@/api/embedded'

export default {
  name: 'buddy-super-light-item',
  data () {
    return {
      confirmXferDlg: false,
      xferCallId: '',
      xferNumber: '',
      dndCallOver: false
    }
  },
  props: {
    buddy: {
      type: Object,
      required: true
    },
    superLightItemSize: {
      type: Number,
      required: false,
      default: 56
    }
  },
  components: {
    StatusAvatar, TransferCallDialog, CallTime
  },
  computed: {
    ...mapGetters({
      canShowCallers: 'permissions/showBuddyCallers',
      compactView: 'users/compactView',
      sort: 'users/sort'
    }),
    embedded () {
      return EmbeddedLocalStorage.get()
    },
    draggable () {
      return this.sort?.match('custom')
    },
    cardClass: function () {
      let css = ''
      if (this.draggable) {
        css = 'buddy-light-item'
      }
      return css
    },
    displayCallers: function () {
      return this.buddy.isOnCall && this.canShowCallers(this.buddy.id)
    },
    badgeSize () {
      return (16 * this.superLightItemSize) / 48
    },
    nameFontSize () {
      return (15 * this.superLightItemSize) / 56
    },
    marginSize () {
      return (6 * this.superLightItemSize) / 56
    },
    cardSize () {
      return (150 * this.superLightItemSize) / 56
    },
    calls () {
      return this.buddy?.calls || []
    },
    buddyExtension () {
      return this.buddy?.exten
    }
  },
  methods: {
    ...mapActions({
      callNumber: 'callNumber'
    }),
    dragOver: function (e) {
      if (e.dataTransfer.types.includes('call/json')) {
        this.dndCallOver = true
      }
    },
    dragLeave: function (e) {
      this.dndCallOver = false
    },
    dndDrop: function (e) {
      if (!this.dndCallOver) return
      const data = e.dataTransfer.getData('call/json')
      if (!data) {
        this.dbg('ERROR: Failed call x-fer. Missing drag-n-drop call json data')
        return
      }
      const call = JSON.parse(data)
      this.xferCallId = call.callid
      this.xferNumber = call.number
      this.dndCallOver = false
      this.confirmXferDlg = true
    },
    closeXferDialog () {
      this.confirmXferDlg = false
      this.xferCallId = ''
      this.xferNumber = ''
    },
    onBuddyClick () {
      this.callNumber({ number: this.buddyExtension })
    }
  }
}
</script>

<style>
.buddy-light-item.v-card { cursor: move; }
.buddy-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px; /* or any other value that you prefer */
}
</style>
